{
    "greeting": "Hej, {name}!",
    "items": "{count, plural, one {# sak} other {# saker}}"
}
